
import { TranslationRecord } from '../../types';

export const company: TranslationRecord = {
  // Company Information
  companyInfo: 'Στοιχεία Εταιρείας',
  companyName: 'Επωνυμία: Χρήστος Αθαν. Πετκάκης & Σια Ε.Ε.',
  vatId: 'ΑΦΜ',
  vatNumber: 'EL092615293',
  address: 'Έδρα',
  companyAddress: 'Ερνέστου Εμπράρ 13, 4ος όροφος, Θεσσαλονίκη, 54625 Ελλάδα',
  gemi: 'ΓΕΜΗ',
  gemiNumber: '038228205000',
};
